export default __webpack_public_path__ + "static/media/ToolUnity1.5337d904.svg";